/** Primary sales / enquiries (shown in header & footers) */
export const SALES_EMAIL = 'info@boldcompsolutions.com';

export function mailtoSales(subject = '') {
  const q = subject ? `?subject=${encodeURIComponent(subject)}` : '';
  return `mailto:${SALES_EMAIL}${q}`;
}
